import { formatCurrency } from '@/utils/Formatters/formatCurrency';

export const getTotalPrice = (month, anual, cycle, amount) => formatCurrency(
  cycle === 'monthly'
    ? month * amount
    : anual * amount,
);
